import {OMNI_EBOOK_SEARCH_RESULT_ITEM_TITLE} from '@/features/search/search-constants.js';
class OmniNormalizer {
	constructor(rawResults) {
		this.data = rawResults.data;
	}

	removeEbooksForNonUSUsers(hits) {
		const userCountryCode = window.storeVariables?.countryCode || '';
		const storeCountryCode = window.dataLayer?.countryCode || '';
		if (userCountryCode !== 'US' && storeCountryCode === 'us') {
				return hits?.filter((item) => !item?.doc?.title?.toLowerCase().includes(OMNI_EBOOK_SEARCH_RESULT_ITEM_TITLE));
		}
		return hits;
	}

	normalizedData() {
		try {
			if (!this.data.search) {
				throw new Error('[ERROR] API issue, check search api results back!!!');
			}
		} catch (e) {
			return { error: e };
		}

		const rawResults = this.data.search;
		const filteredHits = this.removeEbooksForNonUSUsers(rawResults.hits);
		const removedCount = (rawResults.hits.length - filteredHits.length);
		const totalResults = rawResults.count - removedCount;
		let searchResults = {
			totalResults: totalResults,
			resultCards: [],
		};
		if (searchResults.totalResults == 0) {
			return searchResults;
		}
		searchResults.resultCards = filteredHits.map((rawResult) => {
			let card = {};
			let result = rawResult.doc;
			card.title = result.title || '';
			card.content = result.content || '';
			card.description = result.description || '';
			card.pricePrefix = result.metaFields.pricePrefix || '';
			card.productDetailLabel = result.metaFields.productDetailLabel || '';
			card.linkcta1 = result.metaFields.linkcta1 || '';
			card.linkcta2 = result.metaFields.linkcta2 || '';
			card.platform = result.metaFields.platform;
			card.discountText = result.metaFields.discountText || '';
			card.productDetailLink = result.metaFields.productDetailLink || '';
			card.price = result.metaFields.price || '';
			card.productTag = result.metaFields.productTag || '';
			card.labelcta1 = result.metaFields.labelcta1 || '';
			card.labelcta2 = result.metaFields.labelcta2 || '';
			card.productType = result.metaFields.productType || '';
			card.themeColor = result.metaFields.themeColor || '';
			card.productIcon = result.metaFields.productIcon || '';
			card.isCollection = typeof result.metaFields.isCollection == 'undefined' || result.metaFields.isCollection == 'false' ? false : true;
			return card;
		});
		return searchResults;
	}
}

export default OmniNormalizer;
